module.exports = __webpack_public_path__ + "static/media/6.5f45e41f.png";